var _g, _g2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadProductImageFrameTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 122,
    viewBox: "0 0 114 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_267_14127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.6655 2.5554L6.8594 25.1892C3.45938 26.3411 1.63694 30.0312 2.78886 33.4312L30.3696 114.839C31.7932 119.041 36.3645 121.282 40.5581 119.833L105.813 97.2965C109.972 95.8602 112.191 91.335 110.779 87.1677L83.8095 7.5653C82.3918 3.38067 77.8502 1.13766 73.6655 2.5554Z",
    fill: "#EBEBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.717 65.1459C48.782 63.2256 44.0344 64.8255 42.0642 68.7357L27.2395 98.1574C26.2748 100.072 26.1189 102.294 26.8069 104.324L30.2239 114.41C31.6416 118.595 36.1832 120.838 40.3679 119.42L113.059 94.7921L76.9055 76.9497L52.717 65.1459Z",
    fill: "#C3E9C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9055 76.9497L113.059 94.7921L108.964 81.9258L105.696 72.2782C105.015 70.2686 103.563 68.6119 101.661 67.6723L92.7153 63.2542C88.7812 61.3112 84.0162 62.8996 82.0349 66.8146L76.9055 76.9497Z",
    fill: "#C0C0D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.2511,
    cy: 36.4742,
    r: 9.5,
    transform: "rotate(-18.7163 59.2511 36.4742)",
    fill: "#2E3079"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_267_14127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5361 10.9932H21C17.4101 10.9932 14.5 13.9033 14.5 17.4932V103.446C14.5 107.883 18.1105 111.472 22.547 111.446L91.5832 111.04C95.983 111.014 99.5361 107.44 99.5361 103.04V18.9932C99.5361 14.5749 95.9544 10.9932 91.5361 10.9932Z",
    fill: "#EBEBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6117 63.5519C48.5009 60.4705 43.491 60.4623 40.3702 63.5336L16.8886 86.6425C15.3605 88.1463 14.5 90.2005 14.5 92.3444V102.993C14.5 107.411 18.0817 110.993 22.5 110.993H99.25L70.7333 82.4932L51.6117 63.5519Z",
    fill: "#2E3079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7333 82.4932L99.25 110.993L99.5 97.4932V87.3069C99.5 85.1851 98.6571 83.1503 97.1569 81.65L90.1018 74.595C86.9992 71.4924 81.9765 71.4678 78.8437 74.5399L70.7333 82.4932Z",
    fill: "#C0C0D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 38.4932,
    r: 9.5,
    fill: "#2E3079"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 8.99316,
    width: 89,
    height: 104,
    rx: 10,
    stroke: "white",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_267_14127"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.703125,
    y: 27.2749,
    width: 85,
    height: 100,
    rx: 8,
    transform: "rotate(-18.7163 0.703125 27.2749)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_267_14127"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 10.9932,
    width: 85,
    height: 100,
    rx: 8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadProductImageFrameTemp);
export default __webpack_public_path__ + "static/media/upload-product-image-frame-temp.03e4f538e0bafeee6a9c8ed12e3f4984.svg";
export { ForwardRef as ReactComponent };